import {Divider, Flex, Grid, Heading} from "@aws-amplify/ui-react";
import React from "react";
import {useCookies} from "react-cookie";
import {contains, findValueIgnoreCase, remove} from "../commons/Utils/ArrayUtils";
import {adjustItemFromRekognitionForGui, convertToD4ItemForRequest} from "../commons/Converter";
import LocalStorage from "../commons/LocalStorage";
import Utils from "../commons/Utils/Utils";
import {basicApiRekognizeItem, userApiGetUser} from "../commons/api/BasicApi";
import {d4CreateAuction} from "../commons/api/D4Api";
import {
    canHaveAspects,
    canHaveMythicAffix,
    canHaveSetAffix,
    canHaveUniqueAffix,
    CLASSES,
    DEFAULT_ITEM_RARITY,
    isItemWithNeededAspectAsLegendary,
    isLegendaryOrUnique,
    ITEM_RARITIES,
    ITEM_SUB_TYPES_WITH_AMOUNT,
    ITEM_SUB_TYPES_WITHOUT_STATS,
    MODES,
    PLATFORMS,
    REALM,
    REGIONS,
} from "../commons/enums/D4Enums";
import CurrencySelects from "../components/CurrencySelects";
import EiaButton from "../components/EiaButton";
import EiaDropZone from "../components/EiaDropZone";
import EiaHelpButton from "../components/EiaHelpButton";
import EiaImage from "../components/EiaImage";
import AlertCard from "../components/cards/AlertCard";
import EiaCard from "../components/cards/EiaCard";
import D4AffixSelects from "../components/d4/D4AffixSelects";
import D4ImplicitStatSelects from "../components/d4/D4ImplicitStatSelects";
import D4ItemBaseStatSelect from "../components/d4/D4ItemBaseStatSelect";
import D4ItemCard from "../components/d4/D4ItemCard";
import D4ItemSelects from "../components/d4/D4ItemSelects";
import LoadingDialog from "../components/dialogs/LoadingDialog";
import helpBasicStats from './../resources/help/helpBasicStats.jpg';
import helpDetectionError from './../resources/help/helpDetectionError.jpg';
import helpDetectionFix from './../resources/help/helpDetectionFix.jpg';
import helpGameplaySettings from './../resources/help/helpGameplaySettings.jpg';
import helpItemAutoDetection1 from './../resources/help/helpItemAutoDetection1.jpg';
import helpItemAutoDetection2 from './../resources/help/helpItemAutoDetection2.jpg';
import itemPlaceHolder from './../resources/itemPlaceHolder.jpg';
import PriceCheckDialog from "../components/dialogs/PriceCheckDialog";
import YoutubeVideo from "../components/YoutubeVideo";
import {Helmet} from "react-helmet-async";
import {compressImage} from "../commons/Utils/ImageUtils";
import * as ApiUtils from "../commons/api/ApiUtils";
import {GAMES} from "../commons/enums/EiaEnums";
import {MAX_AFFIX_STATS_PER_ITEM, MAX_IMPLICIT_STATS_PER_ITEM} from "../commons/enums/D4Constants";

const isSmallScreen = Utils.isSmallScreen();
const initItemPreview = {
    name: "Axe",
    rarity: DEFAULT_ITEM_RARITY,
    itemType: "Weapon",
    itemSubType: "Two-Handed",
    itemPower: 0,
    dps: 0,
    armor: 0,
    levelRequirement: 0,
    classRequirement: "",
    amount: 1
}

const SellPage = function (props) {
    const {user} = props;

    const [cookies, setCookies, removeCookies] = useCookies(['game', 'mode', 'realm', 'region', 'platform']);

    const cookiesWrapper = {
        game: cookies.game ? cookies.game : GAMES[0],
        mode: cookies.mode ? cookies.mode : MODES[0],
        realm: cookies.realm ? cookies.realm : REALM[0],
        region: cookies.region ? cookies.region : REGIONS[0],
        platform: cookies.platform ? cookies.platform : PLATFORMS[0]
    }

    const [openPriceCheckDialog, setOpenPriceCheckDialog] = React.useState(false);

    const [currency, setCurrency] = React.useState({})

    const [updateImplicitStatsSelects, setUpdateImplicitStatsSelects] = React.useState(false);
    const [updateStatsSelects, setUpdateStatsSelects] = React.useState(false);
    const [updateAspectSelects, setUpdateAspectSelects] = React.useState(false);
    const [updateUniqueAffixesSelects, setUpdateUniqueAffixesSelects] = React.useState(false);
    const [updateSetAffixesSelects, setUpdateSetAffixesSelects] = React.useState(false);
    const [updateMythicAffixesSelects, setUpdateMythicAffixesSelects] = React.useState(false);

    const [itemPreview, setItemPreview] = React.useState(initItemPreview)

    const baseItem = itemPreview === null ? {} : {
        title: itemPreview.title,
        name: itemPreview.name,
        rarity: itemPreview.rarity,
        itemType: itemPreview.type ? itemPreview.type : itemPreview.itemType,
        itemSubType: itemPreview.subType ? itemPreview.subType : itemPreview.itemSubType,
        amount: itemPreview.amount
    }
    const setBaseItem = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.name = newValue.name;
        temp.title = newValue.title;
        temp.type = newValue.itemType;
        temp.itemType = newValue.itemType;
        temp.subType = newValue.itemSubType;
        temp.itemSubType = newValue.itemSubType;
        temp.rarity = newValue.rarity;
        temp.amount = newValue.amount;
        if (!canHaveAspects(temp)) {
            temp.aspects = [];
        }

        setItemPreview(temp);

        setUpdateImplicitStatsSelects(true)
        setUpdateStatsSelects(true)
        setUpdateAspectSelects(true);
        setUpdateUniqueAffixesSelects(true);
        setUpdateSetAffixesSelects(true);
        setUpdateMythicAffixesSelects(true);
    }

    const baseStats = itemPreview == null ? {} : {
        itemPower: itemPreview.itemPower,
        dps: itemPreview.dps,
        armor: itemPreview.armor,
        allResist: itemPreview.allResist,
        levelRequirement: itemPreview.levelRequirement,
        classRequirement: itemPreview.classRequirement
    }
    const setBaseStats = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.itemPower = newValue.itemPower;
        temp.dps = newValue.dps;
        temp.armor = newValue.armor;
        temp.allResist = newValue.allResist;
        temp.levelRequirement = newValue.levelRequirement;
        temp.classRequirement = newValue.classRequirement;
        setItemPreview(temp);
    }

    const implicitStats = itemPreview.basicStats === undefined ? [] : itemPreview.basicStats;
    const setImplicitStats = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.basicStats = newValue;
        setItemPreview(temp);
    }

    const affixStats = itemPreview.stats === undefined ? [] : itemPreview.stats;
    const setAffixStats = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.stats = newValue;
        setItemPreview(temp);
    }

    const aspects = itemPreview.aspects === undefined ? [] : itemPreview.aspects;
    const setAspects = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.aspects = newValue;
        setItemPreview(temp);
    }

    const uniqueAffixes = itemPreview.uniqueAffixes === undefined ? [] : itemPreview.uniqueAffixes;
    const setUniqueAffixes = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.uniqueAffixes = newValue;
        setItemPreview(temp);
    }

    const setAffixes = itemPreview.setAffixes === undefined ? [] : itemPreview.setAffixes;
    const setSetAffixes = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.setAffixes = newValue;
        setItemPreview(temp);
    }

    const mythicAffixes = itemPreview.mythicAffixes === undefined ? [] : itemPreview.mythicAffixes;
    const setMythicAffixes = function (newValue) {
        const temp = Object.assign({}, itemPreview);
        temp.mythicAffixes = newValue;
        setItemPreview(temp);
    }

    const [isLoading, setIsLoading] = React.useState(false)
    const [alert, setAlert] = React.useState(null)

    const [imageBytes, setImageBytes] = React.useState(null);

    const itemCanHaveAspects = canHaveAspects(baseItem);
    const itemCanHaveUniqueAffixes = canHaveUniqueAffix(baseItem);
    const itemCanHaveSetAffixes = canHaveSetAffix(baseItem);
    const itemCanHaveMythicAffixes = canHaveMythicAffix(baseItem);

    const checkUserAndSell = function () {
        setIsLoading(true)

        const request = {
            requestedUser: LocalStorage.getUser()
        }

        userApiGetUser(request, function (response) {
            if (response.user && response.user.battleTag) {
                sell();
            } else {
                setAlert(["error", "BattleTag not configured. Open your profile settings and configure BattleTag to sell items"]);
                setIsLoading(false);
            }
        }, function (error) {
            setAlert(["error", error.message]);
            setIsLoading(false);
        })
    }

    const sell = function () {
        setIsLoading(true)

        const request = ApiUtils.getGameRequest(cookies);

        const itemForRequest = convertToD4ItemForRequest(baseItem, baseStats, implicitStats, affixStats, aspects, uniqueAffixes, setAffixes, mythicAffixes, request.game);
        const isItemWithStats = !contains(ITEM_SUB_TYPES_WITHOUT_STATS, itemForRequest.subType);

        console.log("itemForRequest", itemForRequest)

        if (isItemWithStats && itemForRequest.rarity !== "Normal" && itemForRequest.stats.length === 0) {
            setAlert(["error", "Please use an english item screenshot or enter the item stats manually below"])
            setIsLoading(false);
            return;
        }

        request.currency = currency.name;
        request.item = itemForRequest;
        request.amount = contains(ITEM_SUB_TYPES_WITH_AMOUNT, itemForRequest.subType) ? baseItem.amount : 1;
        request.price = currency.price;

        d4CreateAuction(request, function (response) {
            const itemDescription = response.auction.item.title ? response.auction.item.title : response.auction.item.name;
            setAlert(["success", ("Successfully created auction with item '" + itemDescription + "' for"
                + " " + response.auction.price + " " + response.auction.currency)]);
            setIsLoading(false)
        }, function (error) {
            setAlert(["error", error.message]);
            setIsLoading(false)
        })
    }

    const resetItem = function () {
        setUpdateStatsSelects(false);
        setUpdateImplicitStatsSelects(false);
        setUpdateAspectSelects(false);
        setUpdateUniqueAffixesSelects(false);
        setUpdateSetAffixesSelects(false);
        setUpdateMythicAffixesSelects(false);
        setBaseStats({});
        setImplicitStats([]);
        setAffixStats([]);
        setAspects([]);
        setUniqueAffixes([]);
        setItemPreview(initItemPreview);
    }

    const handleItemRekognition = function (acceptedFiles) {
        resetItem();
        setIsLoading(true)

        if (acceptedFiles.length > 1) {
            alertErrorAndStopLoading("Cannot read multiple files");
            return;
        }

        if (acceptedFiles.length < 1) {
            alertErrorAndStopLoading("No file to read");
            return;
        }

        acceptedFiles.forEach((file) => {
            compressImage(file, 1.0, null, uploadFileForRecognition, alertErrorAndStopLoading);
        })
    }

    const uploadFileForRecognition = function (file) {
        console.log("Uploading file size", file.size)
        const reader = new FileReader()

        reader.onabort = () => alertErrorAndStopLoading("Reading file aborted");
        reader.onerror = () => alertErrorAndStopLoading("Reading file failed");
        reader.onload = () => {
            const imageBytesBase64Encoded = btoa(reader.result)
            setImageBytes(imageBytesBase64Encoded);

            const request = {
                game: "D4",
                imageBytes: imageBytesBase64Encoded
            }

            basicApiRekognizeItem(request, function (response) {
                setAlert(["success", "Successfully read item from image"]);
                setRecognizedItem(response.d4Item);
                setIsLoading(false)
            }, function (error) {
                alertErrorAndStopLoading(error.message);
            })
        }

        reader.readAsBinaryString(file)
    }

    const alertErrorAndStopLoading = function (message) {
        setAlert(["error", message]);
        setIsLoading(false)
    }

    const getClassRequirement = function (value) {
        const classes = remove(CLASSES, ["Any"])
        const result = findValueIgnoreCase(classes, value);
        if (result) {
            return result;
        } else {
            setAlert(["warning", "Successfully read item from image - please double check Class Requirement"]);
            return "";
        }
    }

    const setRecognizedItem = function (d4Item) {
        let error = false;
        let warning = false;

        if (!d4Item) {
            error = "Failed detecting item from image";
        }

        if (d4Item.accountBound === true) {
            error = "Account bound items are not tradeable.";
        }

        d4Item = adjustItemFromRekognitionForGui(d4Item);

        if (d4Item.classRequirement) {
            d4Item.classRequirement = getClassRequirement(d4Item.classRequirement);
        } else {
            d4Item.classRequirement = "";
        }

        if (d4Item.stats) {
            if (d4Item.stats.length > MAX_AFFIX_STATS_PER_ITEM) {
                warning = "Screenshot item has more than "+MAX_AFFIX_STATS_PER_ITEM+" affix stats what is not supported. Fix it manually.";
                d4Item.stats = d4Item.stats.slice(1, 1+MAX_AFFIX_STATS_PER_ITEM);
            }
        }

        if (d4Item.rarity === ITEM_RARITIES[2]) {
            const noAspects = d4Item.aspects === undefined || d4Item.aspects === null || d4Item.aspects.length === 0;
            if (noAspects && isItemWithNeededAspectAsLegendary(d4Item.name)) {
                warning = "No aspect detected - select an aspect manually";
            }
        } else if (d4Item.rarity === ITEM_RARITIES[1]) {
            const noUniqueAffix = d4Item.uniqueAffixes === undefined || d4Item.uniqueAffixes === null || d4Item.uniqueAffixes.length === 0;
            if (noUniqueAffix) {
                warning = "No unique affix detected - select an unique affix manually if needed";
            }
        } else if (d4Item.rarity === ITEM_RARITIES[6]) {
            const noSetAffix = d4Item.setAffixes === undefined || d4Item.setAffixes === null || d4Item.setAffixes.length === 0;
            if (noSetAffix) {
                warning = "No set affix detected - select a set affix manually if needed";
            }
        } else if (d4Item.rarity === ITEM_RARITIES[7]) {
            const noMythicAffix = d4Item.mythicAffixes === undefined || d4Item.mythicAffixes === null || d4Item.mythicAffixes.length === 0;
            if (noMythicAffix) {
                warning = "No mythic affix detected - select a mythic affix manually if needed";
            }
        }

        if (error) {
            setAlert(["error", error]);
        } else {
            if (warning) {
                setAlert(["warning", warning]);
            }
        }

        setItemPreview(d4Item);
        setUpdateImplicitStatsSelects(true)
        setUpdateStatsSelects(true)
        setUpdateAspectSelects(true);
        setUpdateUniqueAffixesSelects(true);
        setUpdateSetAffixesSelects(true);
        setUpdateMythicAffixesSelects(true);
    }

    const tryOpenPriceCheckDialog = function () {
        if (isLegendaryOrUnique(baseItem)) {
            setOpenPriceCheckDialog(true);
        } else {
            setAlert(["warning", "Price Check only works with legendary or unique items."]);
        }
    }

    return (
        <>
            <Helmet>
                <title>Sell – Easy Item Trading</title>
                <link rel="canonical" href={window.location.href}/>
                <meta name="description" content="Sell - Easy Item Trading - sell your items with screenshots and optionally use price-check before selling"/>
            </Helmet>
            {
                <div>
                    <PriceCheckDialog isLoading={isLoading}
                                      openPriceCheckDialog={openPriceCheckDialog}
                                      setOpenPriceCheckDialog={setOpenPriceCheckDialog}
                                      user={user}
                                      currency={currency}
                                      baseItem={baseItem}
                                      baseStats={baseStats}
                                      stats={affixStats}
                                      uniqueAffixes={uniqueAffixes}
                    />
                    <LoadingDialog open={isLoading}/>
                    <AlertCard alert={alert}/>
                    <EiaCard>
                        <Flex>
                            <Heading level={4}>Use screenshot item auto detection (recommended)</Heading>
                            <EiaHelpButton title={"Sell with screenshot auto detection"}>
                                <Flex direction={"column"}>
                                    <Heading level={4}>English</Heading>
                                    <YoutubeVideo src={"https://www.youtube.com/embed/FYqNQPBhiKc?si=EH78WTXxsFfnAnUP"}/>
                                    <Heading level={4}>German</Heading>
                                    <YoutubeVideo src={"https://www.youtube-nocookie.com/embed/euVuzxbAtK0?si=2M6lyV_tDqjG0wfo"}/>
                                </Flex>
                            </EiaHelpButton>
                        </Flex>
                        <Divider></Divider>
                    </EiaCard>
                    <Grid templateColumns="3fr 3fr 3fr 3fr">
                        <EiaCard columnStart="1" columnEnd={isSmallScreen ? "-1" : "1"}>
                            <Heading level={4}>Auto detection image upload</Heading>
                            <EiaDropZone handleFiles={handleItemRekognition} isLoading={isLoading}/>
                        </EiaCard>
                        <EiaCard columnStart={isSmallScreen ? "1" : "2"} columnEnd={isSmallScreen ? "-1" : "2"}>
                            <Flex>
                                <Heading level={4}>Auto detection image</Heading>
                                <EiaHelpButton title={"Auto detection help"}>
                                    <Heading level={5}>1. Set game language to english</Heading>
                                    <Heading level={5}>2. Disable 'Advanced Tooltip Compare'</Heading>
                                    <Heading level={5}>3. Enable 'Advanced Tooltip Information'</Heading>
                                    <EiaImage src={helpGameplaySettings}/>
                                    <Flex justifyContent={"space-around"}>
                                        <EiaImage objectFit="cover" height={300}
                                                  src={helpItemAutoDetection1}/>
                                        <EiaImage objectFit="cover" height={300}
                                                  src={helpItemAutoDetection2}/>
                                    </Flex>
                                </EiaHelpButton>
                            </Flex>
                            <EiaImage objectFit="cover" height={300}
                                      src={imageBytes ? `data:image/jpeg;base64,${imageBytes}` : itemPlaceHolder}/>
                        </EiaCard>
                        <EiaCard columnStart={isSmallScreen ? "1" : "3"} columnEnd={isSmallScreen ? "-1" : "3"}>
                            <Flex>
                                <Heading level={4}>Sell item preview</Heading>
                                <EiaHelpButton title={"Item Preview help"}>
                                    <Heading level={5}>After uploading your item image you could see detection errors like</Heading>
                                    <EiaImage src={helpDetectionError}/>
                                    <Heading level={5}>Then scroll down and fix manually wrong values and add missing affixes / aspects</Heading>
                                    <EiaImage src={helpDetectionFix}/>
                                </EiaHelpButton>
                            </Flex>

                            {itemPreview ? <D4ItemCard item={itemPreview} amount={itemPreview.amount}/> : null}
                        </EiaCard>
                        <EiaCard columnStart={isSmallScreen ? "1" : "4"} columnEnd={isSmallScreen ? "-1" : "4"}>
                            <Flex direction="column" justifyContent="space-between">
                                <Heading level={4}>What is your price?</Heading>
                                <CurrencySelects currency={currency} setCurrency={setCurrency} addPrice={true} amount={baseItem.amount} setAlert={setAlert} game={cookiesWrapper.game}/>
                                <EiaButton isFullWidth onClick={tryOpenPriceCheckDialog} disabled={isLoading}
                                           tooltip={"Check the price for the selected item"}>Price Check ...</EiaButton>
                                <EiaButton colorTheme={"success"} isFullWidth onClick={checkUserAndSell} disabled={isLoading}
                                           tooltip={"Create a sale for the selected item and price"}>Sell</EiaButton>
                            </Flex>
                        </EiaCard>
                        <EiaCard columnStart="1" columnEnd="5">
                            <Heading level={4}>Manual select or edit item</Heading>
                            <Divider></Divider>
                        </EiaCard>
                        <EiaCard
                            columnStart="1"
                            columnEnd={isSmallScreen ? "-1" : "1"}
                        >
                            <D4ItemSelects showAmount={true} baseItem={baseItem} setBaseItem={setBaseItem} removeAny={true}/>
                        </EiaCard>
                        <EiaCard
                            columnStart={isSmallScreen ? "1" : "2"}
                            columnEnd={isSmallScreen ? "-1" : "2"}
                        >
                            <Flex direction="column" justifyContent="space-between">
                                <Flex>
                                    <Heading level={4}>Basic Stats</Heading>
                                    <EiaHelpButton title={"Where are the basic stats?"}>
                                        <Flex justifyContent={"space-around"}>
                                            <EiaImage objectFit="cover" height={300}
                                                      src={helpBasicStats}/>
                                        </Flex>
                                    </EiaHelpButton>
                                </Flex>
                                <D4ItemBaseStatSelect baseItem={baseItem} baseStats={baseStats} setBaseStats={setBaseStats}/>
                            </Flex>
                        </EiaCard>
                        {
                            contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ? null :
                                <EiaCard
                                    columnStart={isSmallScreen ? "1" : "3"}
                                    columnEnd={isSmallScreen ? "-1" : "3"}
                                >
                                    <D4ImplicitStatSelects
                                        size={MAX_IMPLICIT_STATS_PER_ITEM}
                                        implicitStats={implicitStats}
                                        setImplicitStats={setImplicitStats}
                                        updateImplicitStatsSelects={updateImplicitStatsSelects}
                                        setAlert={setAlert}
                                    />
                                </EiaCard>
                        }
                        {
                            contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ? null :
                                <EiaCard
                                    columnStart={isSmallScreen ? "1" : "4"}
                                    columnEnd={isSmallScreen ? "-1" : "4"}
                                >
                                    <D4AffixSelects
                                        setAlert={setAlert}
                                        size={MAX_AFFIX_STATS_PER_ITEM}
                                        affixStats={affixStats} setAffixStats={setAffixStats}
                                        updateStatsSelects={updateStatsSelects}

                                        aspects={aspects} setAspects={setAspects}
                                        updateAspectSelects={updateAspectSelects}
                                        itemCanHaveAspects={itemCanHaveAspects}

                                        uniqueAffixes={uniqueAffixes} setUniqueAffixes={setUniqueAffixes}
                                        updateUniqueAffixesSelects={updateUniqueAffixesSelects}
                                        itemCanHaveUniqueAffixes={itemCanHaveUniqueAffixes}

                                        setAffixes={setAffixes} setSetAffixes={setSetAffixes}
                                        updateSetAffixesSelects={updateSetAffixesSelects}
                                        itemCanHaveSetAffixes={itemCanHaveSetAffixes}

                                        mythicAffixes={mythicAffixes} setMythicAffixes={setMythicAffixes}
                                        updateMythicAffixesSelects={updateMythicAffixesSelects}
                                        itemCanHaveMythicAffixes={itemCanHaveMythicAffixes}
                                    />
                                </EiaCard>
                        }
                    </Grid>
                </div>
            }
        </>
    );
}
export default SellPage;